// components/UpgradePrompt/UpgradePrompt.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Crown, Zap } from 'lucide-react';
import './UpgradePrompt.css';

const FEATURE_NAMES = {
  abc_classification:          'ABC Product Classification',
  customer_segments:           'Customer Segmentation',
  predictive_recommendations:  'Predictive Restock Recommendations',
  churn_prediction:            'Churn Prediction',
  rfm_analysis:                'RFM Analysis',
};

// ── DEFENSIVE: works even if parent forgets to pass onClose ──────────────────
function UpgradePrompt({ feature, onClose, plan = 'Business' }) {
  const navigate = useNavigate();

  // Close on ESC key
  useEffect(() => {
    const fn = (e) => { if (e.key === 'Escape') close(); };
    window.addEventListener('keydown', fn);
    return () => window.removeEventListener('keydown', fn);
  }, []);

  // Prevent body scroll while open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  function close() {
    if (typeof onClose === 'function') {
      onClose();
    } else {
      // Fallback: if parent forgot onClose, try to navigate back
      console.warn('UpgradePrompt: onClose prop not provided — using fallback');
      navigate(-1);
    }
  }

  function handleUpgrade(e) {
    e.stopPropagation();
    close();
    navigate('/subscribe');
  }

  function handleOverlayClick(e) {
    // Only close if clicking the overlay itself, not the modal
    if (e.target === e.currentTarget) close();
  }

  return (
    <div className="up-overlay" onClick={handleOverlayClick}>
      <div className="up-modal">

        {/* Close button */}
        <button className="up-close" onClick={close} type="button" aria-label="Close">
          <X size={16} />
        </button>

        {/* Icon */}
        <div className="up-icon">
          <Crown size={28} />
        </div>

        {/* Headline */}
        <h2 className="up-title">{plan} Plan Required</h2>

        {/* Feature callout */}
        <div className="up-feature">
          <Zap size={13} />
          {FEATURE_NAMES[feature] || 'This feature'}
        </div>

        <p className="up-desc">
          Upgrade to the {plan} plan to unlock this and other
          advanced features for your team.
        </p>

        {/* Pricing hint */}
        <div className="up-pricing">
          <span className="up-pricing__monthly">€75<span>/mo</span></span>
          <span className="up-pricing__or">or</span>
          <span className="up-pricing__once">€750 one-time</span>
        </div>

        {/* CTA */}
        <button className="up-btn" onClick={handleUpgrade} type="button">
          Upgrade to {plan} →
        </button>

        <p className="up-note">No credit card required during trial</p>
      </div>
    </div>
  );
}

export default UpgradePrompt;